export default "__VITE_PUBLIC_ASSET__2c69c50a__"